import React, { useEffect, useRef } from 'react';
import { Platform, Animated } from 'react-native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Octicons, Ionicons } from '@expo/vector-icons';
import { TimelineScreen } from '../screens/TimelineScreen';
import { SearchScreen } from '../screens/SearchScreen';
import { NotificationsScreen } from '../screens/NotificationsScreen';
import { ProfileScreen } from '../screens/ProfileScreen';
import VideoTopScreen from '../screens/VideoTopScreen';
import { colors } from '../utils/colors';

export type MainTabParamList = {
  Home: undefined;
  Videos: undefined;
  Search: undefined;
  Notifications: undefined;
  Profile: undefined;
};

const Tab = createBottomTabNavigator<MainTabParamList>();

const AnimatedIcon = ({ name, focused, color, size, library = 'Octicons' }: { name: any, focused: boolean, color: string, size: number, library?: 'Octicons' | 'Ionicons' }) => {
  const scaleAnim = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    Animated.spring(scaleAnim, {
      toValue: focused ? 1.1 : 1,
      useNativeDriver: true,
      friction: 4,
    }).start();
  }, [focused]);

  return (
    <Animated.View style={{ transform: [{ scale: scaleAnim }] }}>
      {library === 'Octicons' ? (
        <Octicons name={name} size={size} color={color} />
      ) : (
        <Ionicons name={name} size={size} color={color} />
      )}
    </Animated.View>
  );
};

export const MainTabNavigator: React.FC = () => {
  return (
    <Tab.Navigator
      initialRouteName="Videos"
      screenOptions={({ route }) => ({
        tabBarIcon: ({ focused, color, size }) => {
          if (route.name === 'Videos') {
            return (
              <AnimatedIcon 
                name={focused ? 'home' : 'home-outline'} 
                focused={focused} 
                color={color} 
                size={size} 
                library="Ionicons" 
              />
            );
          }

          let iconName: keyof typeof Octicons.glyphMap;
          if (route.name === 'Profile') {
            iconName = focused ? 'person-fill' : 'person';
          } else {
            iconName = 'question';
          }

          return <AnimatedIcon name={iconName} focused={focused} color={color} size={size} />;
        },
        tabBarActiveTintColor: '#fff',
        tabBarInactiveTintColor: '#aaa',
        tabBarShowLabel: true,
        tabBarLabelStyle: {
          fontSize: 10,
          fontWeight: '600',
        },
        tabBarItemStyle: {
          paddingVertical: 4,
        },
        tabBarStyle: {
          backgroundColor: '#000',
          borderTopColor: '#222',
          borderTopWidth: 1,
          height: 60,
          paddingBottom: 8,
          paddingTop: 4,
          ...Platform.select({
            web: {
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 1000,
            } as any,
          }),
        },
        headerShown: false,
      })}
    >
      <Tab.Screen
        name="Videos"
        component={VideoTopScreen}
        options={{ title: 'ホーム', tabBarLabel: 'ホーム' }}
      />
      <Tab.Screen
        name="Profile"
        component={ProfileScreen}
        options={{ title: 'ライブラリ', tabBarLabel: 'ライブラリ' }}
      />
    </Tab.Navigator>
  );
};
